// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeartFilledSvg from "@fishx/icons-svg/es/asn/HeartFilled";
import FishxIcon from '../components/FishxIcon';

var HeartFilled = function HeartFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeartFilledSvg
  }));
};

HeartFilled.displayName = 'HeartFilled';
export default React.forwardRef(HeartFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HeartFilled.js
// module id = 2911
// module chunks = 0